// eslint-disable-next-line import/no-cycle
import store from '@/store';
import * as types from './types';

export default {
  startLoading(context) {
    context.commit(types.SET_IS_LOADING, true);
  },
  finishLoading(context) {
    context.commit(types.SET_IS_LOADING, false);
  },
  startSearch(context) {
    context.commit(types.SET_IS_SEARCHING, true);
  },
  resetSearch(context) {
    context.commit(types.SET_IS_SEARCHING, false);
  },
  setIsLoading(context, params) {
    context.commit(types.SET_IS_LOADING, params);
  },
  setIsSearching(context, params) {
    context.commit(types.SET_IS_SEARCHING, params);
  },
  resetChangeRoute(context) {
    context.commit(types.SET_IS_SEARCHING, false);
    store.dispatch('boxes/resetResult', []);
    store.dispatch('logs/resetResult', []);
  },

  // Alert system
  pushAlert({ commit, state }, payload) {
    const theCommit = commit(types.PUSH_ALERT, payload);
    if (payload.type && payload.type === 'success') {
      setTimeout(() => {
        commit(types.REMOVE_ALERT, state.alerts[state.alerts.length - 1].id);
      }, 5000);
    }
    return theCommit;
  },
  updateAlert({ commit }, value) {
    commit(types.UPDATE_ALERT, value);
  },
  removeAlert({ commit }, payload) {
    commit(types.REMOVE_ALERT, payload);
  },
  resetAlert({ commit }, payload) {
    return commit(types.RESET_ALERT, payload);
  },
  setTimelineFixed({ commit }, payload) {
    commit(types.SET_TIMELINE_FIXED, payload);
  },
  setIsMiniVariant({ commit }, payload) {
    commit(types.SET_IS_MINI_VARIANT, payload);
  },
};
